<template>
    <div :key="$store.getters['resource/currentResource'].key">

        <help :title="$t('help.promos_used_title')" >
            <div v-if="promo"
                 slot="text"
                 class="p-3">Code: <router-link :to="'/promos/edit/' + promo.id">{{promo.title}}</router-link></div>
        </help>

      <filters
          class="white-container promo-users-filter"
          :inputs="filters"
          @filter="filter"
          :extend-button="false"
          :extended="extended"
          :filters="filterObject"
          global-filter="users.global"
          :loading="loading"
      />

        <div class="position-relative">

            <loader v-if="loading"/>

            <v-server-table
                    ref="appTable"
                    name="promoUsersTable"
                    class="white-container"
                    :url="tableFetchURL"
                    :columns="columns"
                    :options="options"
                    @loaded="loading = false"
                    @loading="loading = true">

                <template slot="beforeFilter" class="w-100">
                    <div class="w-100 d-flex flex-row flex-wrap">
                        <div class="mt-2 d-flex flex-row align-items-center ml-4">
                            <b-input
                                    v-model="targetEmail"
                                    id="target_email"
                                    type="email"
                                    class="w-50 rounded"
                                    name="target_email"
                                    placeholder="Enter recipient email">
                            </b-input>
                            <i class="far fa-file-excel fa-lg ml-1 mr-1 text-primary d-block"></i>
                            <b-link @click="generateXmlList({filter: params, download: true, email: targetEmail}, 'users')">
                                {{$t('global.generate_send_on_email')}}
                            </b-link>
                        </div>
                    </div>
                </template>
                <template slot="id" slot-scope="props">
                    <span>{{props.row.id}}</span>
                </template>
                <template slot="beforeLimit" v-if="totalRecordsCount > 10">
                    {{$t('global.showing')}}&nbsp;
                </template>
                <template slot="afterLimit" v-if="totalRecordsCount > 10">
                    &nbsp;{{$t('global.of_records_found', {number: totalRecordsCount})}}
                </template>
                <template slot="full_name" slot-scope="props">
                    <router-link :to="{path: `/users/edit/${props.row.id}`, params: props.row}" target="_blank">
                        <span class="text-capitaliloadingze">{{props.row.first_name}} {{props.row.last_name}}</span>
                    </router-link>
                </template>
                <template slot="used_at" slot-scope="props">
                    <span v-if="props.row.transaction">{{formatDate(props.row.transaction.created_at, 'L')}}</span>
                    <span v-else>—</span>
                </template>
                <template slot="transaction_id" slot-scope="props">
                    <router-link v-if="props.row.transaction"
                                 :to="{path: `/transactions/edit/${props.row.transaction.id}`, params: props.row}"
                                 target="_blank">
                        {{props.row.transaction.id}}
                    </router-link>
                    <span v-else>—</span>
                </template>
                <template slot="purchase_name" slot-scope="props">
                    <span v-if="props.row.transaction && props.row.transaction.item_type === 'subscription' && props.row.transaction.sub_title">
                        {{getTransactionData(props.row.transaction, 'sub_title')}} ({{getTransactionData(props.row.transaction, 'plan_title')}})
                    </span>
                    <span v-else>{{getTransactionData(props.row.transaction, 'item_title')}}</span>
                </template>
                <template slot="transaction_total" slot-scope="props">
                    <span v-if="props.row.transaction && props.row.transaction.price !== undefined">
                        {{formatToDollars(props.row.transaction.price).toLocaleString()}} {{props.row.transaction.currency}}
                    </span>
                    <span v-else>—</span>
                </template>
                <template slot="transaction_discounted_total" slot-scope="props">
                    <span v-if="props.row.transaction && props.row.transaction.sub_total !== undefined">
                        {{formatToDollars(props.row.transaction.sub_total).toLocaleString()}} {{props.row.transaction.currency}}
                    </span>
                    <span v-else>—</span>
                </template>
            </v-server-table>
        </div>
    </div>
</template>

<script>
  import axios from '@/utils/axios';
  import i18n from "@/utils/i18n";
  import promoUsersFilters from './promoUsersFilters';
  import filters from '@/components/global/filters'
  import {Event} from "vue-tables-2";

  export default {
    name: "PromoUsers",
    middleware: 'auth',
    components: {
      filters
    },
    data() {
      return {
        loading: false,
        targetEmail: null,
        params: {
          filter: {}
        },
        columns: ['id', 'full_name', 'email', 'transaction_id', 'used_at', 'purchase_name', 'transaction_total', 'transaction_discounted_total'],
        filters: promoUsersFilters,
        filterObject: {},
        extended: true,
        usersFiltered: false,
        options: {
          skin: [],
          headings: {
            id: '#',
            full_name: i18n.t('users.full_name'),
            email: i18n.t('users.email'),
            used_at: i18n.t('promo.used_at'),
            transaction_id: i18n.t('transactions.transaction_id'),
            purchase_name: i18n.t('transactions.purchase_name'),
            transaction_total: i18n.t('transactions.amount'),
            transaction_discounted_total: i18n.t('transactions.discounted_amount')
          },
          dateColumns: ['used_at'],
          sortable: [],
          clientMultiSorting: false,
          customFilters: ['custom'],
          perPage: !!localStorage.getItem('perPage') && localStorage.getItem('perPage') !== '' ? localStorage.getItem('perPage') : 10,
          filterable: false,
          requestFunction: function (data) {
            let params = {};
            params.limit = data.limit;
            params.filter = data.custom;
            params.page = data.page;

            localStorage.setItem('perPage', data.limit);
            return axios.get(this.url, {
              params: params
            }).catch((e) => {
              // this.$noty.error(e.error_description);
              this.dispatch('error', e);
            });
          },
          responseAdapter: function (resp) {
            let data = this.getResponseData(resp);
            return {
              data: data ? data.data.items : [],
              count: data ? data.data.paginator.total_items : 0
            }
          }
        },
        totalRecordsCount: 0,
        show: false,
        promo: null
      }
    },
    created() {
      this.show = !!this.$route.params.id;
      if (!this.$route.params.id) {
        this.$router.push({path: '/promos'})
      }

      this.fetchPromo(this.$route.params.id);
    },
    methods: {
      getTransactionData(transaction, key) {
        if (!transaction) return '—';

        return transaction[key] || '—';
      },
      fetchPromo(id) {
        axios.get('/admin/promos/' + id).then(({data}) => {
          if (data) {
            this.promo = data;
            this.params = {"promoActivations.promo_id" : this.promo.id};
          }
        }).catch((e) => {
          this.dispatch('error', e);
        });
      },
      filter(params) {
        this.params = params;
        Event.$emit('vue-tables.promoUsersTable.filter::custom', params)
      }
    },
    computed: {
      tableFetchURL() {
        return "/admin/promos/info/" + this.$route.params.id;
      },
    },
  }
</script>